<template>
  <footer class="zui-footer">
    <div class="links">
      <a href="/">回到首页</a>
      <!-- <a href="/pricing">定价</a> -->
      <a href="/product">产品中心</a>
      <a href="/aboutus">关于我们</a>
    </div>
    <p class="copy-right">
      ©2019-2021 武汉多普云科技有限公司 版权所有
      <a
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        style="color: #ccc;text-decoration: none;"
        >鄂ICP备19030471号-2</a
      >
      <br />
    </p>
    <div class="sweep-code">
      <img src="https://dl.dpgrid.com/www/imgs/Customerservice.jpg" alt="" />
      <img src="https://dl.dpgrid.com/www/imgs/OfficialAccounts.jpg" alt="" />
    </div>
  </footer>
</template>
<script>
import "./less/footer.less";
// import Customerservice from '../assets/img/Customerservice.jpg';
// import OfficialAccounts from '../assets/img/OfficialAccounts.jpg';
export default {
  data() {
    return {
      // Customerservice: Customerservice,
      // OfficialAccounts: OfficialAccounts
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue